import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { LoadingWrapper, Svg, Circle } from './styles';
import colors from '../theme/colors';
import theme from '../theme/defaultTheme';
var SIZE = 44;

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  return (clampedValue - min) / (max - min);
}

function easeOut(t) {
  var time = getRelativeValue(t, 0, 1);
  time = (time -= 1) * time * time + 1; // https://gist.github.com/gre/1650294

  return time;
}

function easeIn(t) {
  return t * t;
}

var CircularLoading = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
      classes = props.classes,
      width = props.width,
      color = props.color,
      size = props.size,
      style = props.style,
      variant = props.variant,
      thickness = props.thickness,
      value = props.value,
      rest = _objectWithoutProperties(props, ["className", "classes", "width", "color", "size", "style", "variant", "thickness", "value"]);

  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);

    if (variant === 'static') {
      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
      rootStyle.transform = 'rotate(-90deg)';
    } else {
      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
    }
  }

  return /*#__PURE__*/React.createElement(LoadingWrapper, _extends({
    className: clsx(className, classes.root),
    ref: ref,
    role: "progressbar",
    theme: theme,
    color: color,
    style: _extends({
      width: +size,
      height: +size
    }, rootStyle, style),
    variant: variant
  }, rootProps, rest), /*#__PURE__*/React.createElement(Svg, {
    className: clsx(classes.svg),
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, /*#__PURE__*/React.createElement(Circle, {
    variant: variant,
    className: clsx(classes.circle),
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness,
    style: circleStyle
  })));
});
process.env.NODE_ENV !== "production" ? CircularLoading.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    svg: PropTypes.string,
    circle: PropTypes.string
  }),
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  thickness: PropTypes.number,
  value: PropTypes.number,
  variant: PropTypes.oneOf(['determinate', 'indeterminate', 'static'])
} : void 0;
CircularLoading.defaultProps = {
  classes: {
    root: '',
    svg: '',
    circle: ''
  },
  color: colors.periwinkle,
  size: 40,
  thickness: 3.6,
  value: 0,
  variant: 'indeterminate'
};
export default CircularLoading;